import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

const GreyBgCard = styled(Box)(({ theme }) => ({
  borderRadius: theme.spacing(0.5),
  backgroundColor: theme.palette.grey[200],
}));

export default GreyBgCard;
